import { logEvent } from '@/hooks/useClickEventTracking';

import { User } from '@/utils/interfaces/User';

export interface IEvent {
  event_name: string | null;
  source:
    | 'bundles'
    | 'courses'
    | 'schools'
    | 'books'
    | 'live'
    | 'message'
    | 'shop'
    | 'global'
    | 'ask_ai'
    | 'ecom'
    | 'subscription';
  source_type:
    | 'bundles'
    | 'long'
    | 'courses'
    | 'workshop'
    | 'schools'
    | 'cart'
    | 'orders'
    | 'hardcopy'
    | 'digital'
    | 'paperback';
  source_id?: string | null;
  sub_source?: string | null;
  source_name?: string | null;
  sub_source_name?: string | null;
  sub_source_id?: string | null;
  zl_uid?: string | undefined;
  activity_start?: string | undefined;
  activity_end?: string | undefined;
  unit?: string | undefined;
  value?: string | number | undefined;
  meta?: Record<string, any>;
  currency?: string | undefined;
}

const googleDataLayer =
  typeof window !== 'undefined' && (window as any).dataLayer;

export const EventV2 = ({
  payload,
  userData,
  pathname,
}: {
  payload: IEvent;
  userData?: User | undefined;
  pathname?: string;
}) => {
  googleDataLayer?.push({
    event: payload.event_name,
    ecommerce: {
      ...payload,
    },
  });

  logEvent({
    eventDetails: payload,
    userData: userData,
    pathname: pathname as string,
  });
};
